import { cn } from "@/shared/ui/cn";

interface BrandMarkProps {
  className?: string;
}

/**
 * The NexBorg Access app mark: a bold "A" beside the scan frame (four corner brackets round a keyhole).
 * The glyph geometry is `nex-access-control-docs/brand/logos/favicon.svg` with its tile dropped, so the
 * tile around it is the design tokens' (`bg-accent`, `text-on-accent`) and the mark follows light and dark
 * mode. The viewBox crops to the glyphs (x 67.85–448.75, y 166–344 of the 512 source) plus a 12-unit
 * margin, keeping them centred. Decorative: the tile in `Brand` carries the accessible name.
 */
export function BrandMark({ className }: BrandMarkProps) {
  return (
    <svg
      viewBox="56 154 405 202"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn("h-auto", className)}
    >
      <path d="M67.85 343.5 131.85 166H182.25L246.25 343.5H201.55L190 310H123.9L112.35 343.5ZM135.75 275.4H178.35L157.15 212.95Z" />
      <rect x="272.75" y="168" width="63.36" height="29.04" rx="14.52" />
      <rect x="272.75" y="168" width="29.04" height="63.36" rx="14.52" />
      <rect x="385.39" y="168" width="63.36" height="29.04" rx="14.52" />
      <rect x="419.71" y="168" width="29.04" height="63.36" rx="14.52" />
      <rect x="272.75" y="314.96" width="63.36" height="29.04" rx="14.52" />
      <rect x="272.75" y="280.64" width="29.04" height="63.36" rx="14.52" />
      <rect x="385.39" y="314.96" width="63.36" height="29.04" rx="14.52" />
      <rect x="419.71" y="280.64" width="29.04" height="63.36" rx="14.52" />
      <circle cx="360.75" cy="243.68" r="26.4" />
      <path d="M347.55 243.68H373.95L385.39 291.2Q385.39 296.48 380.11 296.48H341.39Q336.11 296.48 336.11 291.2Z" />
    </svg>
  );
}
